export default "__VITE_ASSET__9c6a1e6d__"